import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import { useMemo } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import { projectDocumentSchema, ProjectRole } from "../../types/firestore";
import { getFirestore, doc } from "firebase/firestore";
import LoadingAlert from "../../components/common/loadingAlert";

const auth = getAuth();
const firestore = getFirestore();

export default function DocumentsStart() {
	const navigate = useNavigate();

	const [user, userLoading] = useAuthState(auth);

	if (!user && !userLoading) {
		navigate("/account");
	}

	const { projectId } = useParams();
	if (!projectId) throw "DocumentsStart page requires a projectId parameter.";

	const projectDocumentRef = useMemo(
		() =>
			doc(firestore, "Projects", projectId).withConverter(
				getFirestoreZodConverter(projectDocumentSchema),
			),
		[projectId],
	);

	const [projectDocument, , projectDocumentError] = useDocumentData(projectDocumentRef);

	if (!user || !projectDocument) {
		return <LoadingAlert error={projectDocumentError} />;
	}

	const role = projectDocument.Members[user.uid];
	const isAdmin = role === ProjectRole.Owner || role === ProjectRole.Admin;

	return (
		<div>
			<div className="mb-2">
				<b>Dokumente</b>
			</div>
			<Card role="button" className="mb-2 clickable-card" onClick={() => navigate("project")}>
				<Card.Body>
					<Row>
						<Col xs="auto">
							<i className="bi bi-file-earmark-ppt fs-1" />
						</Col>
						<Col className="d-flex align-items-center">
							<div>
								<div>Projektdokumente</div>
								<small className="text-muted">
									Dokumente, welche für alle Benutzer des Projekts verfügbar sind.
								</small>
							</div>
						</Col>
					</Row>
				</Card.Body>
			</Card>
			<Card
				role="button"
				className="mb-2 clickable-card"
				onClick={() => {
					if (isAdmin) navigate("users");
					else navigate("users/" + user.uid);
				}}>
				<Card.Body>
					<Row>
						<Col xs="auto">
							<i className="bi bi-file-earmark-person fs-1" />
						</Col>
						<Col className="d-flex align-items-center">
							<div>
								<div>Benutzerdokumente</div>
								<small className="text-muted">
									Dokumente, welche nur für einzelne Benutzer verfügbar sind.
								</small>
							</div>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</div>
	);
}
